import { Vsm, VsmVergelijking } from "@/entities/vsm";
import { ReactNode, useMemo } from "react";
import { useVsmEditorContext } from "./vsm-editor-context";
import { VsmVergelijkingContext, VsmVergelijkingContextType, vsmVergelijkingDefaults } from "./vsm-vergelijking-context";

type VsmVergelijkingProviderProps = {
    children: ReactNode;
    // Without a huidige versie there is nothing to compare, so nothing is tagged.
    huidigeVsm: Vsm | null | undefined;
};

/**
 * Compares de nieuwe versie, owned by the VsmEditorProvider, against de huidige versie.
 *
 * The comparison is derived state. It is never stored and never written onto the maatregelen
 * themselves. Every mutation in the editor replaces the maatregelen array, so the memo invalidates
 * and the comparison re-runs on open and after every change the user makes.
 */
export function VsmVergelijkingProvider({ children, huidigeVsm }: Readonly<VsmVergelijkingProviderProps>) {
    const { maatregelen, status } = useVsmEditorContext();

    const contextValue = useMemo((): VsmVergelijkingContextType => {
        if (!huidigeVsm) {
            return vsmVergelijkingDefaults;
        }
        return {
            ...VsmVergelijking.compare(maatregelen, huidigeVsm.maatregelen),
            isStatusGewijzigd: VsmVergelijking.isStatusGewijzigd(status, huidigeVsm.vsmStatus),
        };
    }, [maatregelen, huidigeVsm, status]);

    return <VsmVergelijkingContext value={contextValue}>{children}</VsmVergelijkingContext>;
}
